(function () {
  if (window.__GA_COLLECTION_PAGE_FOUNDATION__) return;
  window.__GA_COLLECTION_PAGE_FOUNDATION__ = true;

  function replaceCorruptedText(root) {
    if (!root || !root.querySelectorAll) return;

    var chips = root.matches && root.matches('.ga-filter-chip')
      ? [root]
      : root.querySelectorAll('.ga-filter-chip');

    Array.prototype.forEach.call(chips, function (chip) {
      var walker = document.createTreeWalker(chip, NodeFilter.SHOW_TEXT);
      var node;

      while ((node = walker.nextNode())) {
        node.nodeValue = node.nodeValue
          .replace(/√ó/g, '×')
          .replace(/‚Ç¨/g, '€')
          .replace(/‚Äì/g, '–');
      }
    });
  }

  function setGuideState(section, expanded) {
    var button = section.querySelector('[data-ga-collection-guide-toggle]');
    if (!button) return;

    section.classList.toggle('is-expanded', expanded);
    section.classList.toggle('is-collapsed', !expanded);
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    var more = button.querySelector('[data-ga-guide-more]');
    var less = button.querySelector('[data-ga-guide-less]');

    if (more) more.hidden = expanded;
    if (less) less.hidden = !expanded;
  }

  function initialiseGuides(root) {
    var guides = root && root.matches && root.matches('[data-ga-collection-guide]')
      ? [root]
      : (root || document).querySelectorAll('[data-ga-collection-guide]');

    Array.prototype.forEach.call(guides, function (section) {
      if (section.dataset.gaGuideReady === 'true') return;
      section.dataset.gaGuideReady = 'true';
      setGuideState(section, false);
    });
  }

  function initialise(root) {
    replaceCorruptedText(root || document);
    initialiseGuides(root || document);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ga-collection-guide-toggle]');
    if (!button) return;

    var section = button.closest('[data-ga-collection-guide]');
    if (!section) return;

    var expanded = button.getAttribute('aria-expanded') === 'true';
    setGuideState(section, !expanded);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialise(document);
    });
  } else {
    initialise(document);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      Array.prototype.forEach.call(mutation.addedNodes, function (node) {
        if (node.nodeType === 1) initialise(node);
      });
    });
  });

  function startObserver() {
    var target = document.querySelector('main') || document.body;
    if (target) observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
